import { render, staticRenderFns } from "./termsAgreement.vue?vue&type=template&id=5c57958f&scoped=true&"
import script from "./termsAgreement.vue?vue&type=script&lang=js&"
export * from "./termsAgreement.vue?vue&type=script&lang=js&"
import style0 from "./termsAgreement.vue?vue&type=style&index=0&id=5c57958f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c57958f",
  null
  
)

export default component.exports